/**
 * Статьи Книги Знаний, перенесённые в кабинет.
 *
 * Перенос из блога в GitBook (Максим 22.08.2026) закончен 24.08.2026:
 * сорок девять пунктов оглавления из пятидесяти открываются внутри кабинета.
 * Не перенесён один — «Бурятия, Аршан»: в блоге эта страница пустая, там
 * только заголовок. Как только Максим пришлёт текст, статья добавляется сюда
 * и пункт разворачивается внутрь, как остальные.
 *
 * Одна статья часто закрывает несколько пунктов оглавления: разделы
 * приложения FairyTON описаны блоками внутри одной статьи, кейсы — тоже.
 * Это сделано намеренно: одиннадцать кейсов подряд человек читает как обзор,
 * а одиннадцать отдельных страниц — как каталог, по которому надо кликать.
 *
 * Тексты переписаны под кабинет, а не скопированы дословно: в блоге они
 * обращаются к постороннему читателю и зазывают зарегистрироваться, а
 * здесь человек уже внутри. Смысл и состав разделов сохранены.
 *
 * Как только статья появляется здесь, в оглавлении (toc.js) у неё меняется
 * href на to — и ссылка ведёт внутрь кабинета, а не наружу.
 */

export const ARTICLES = [
  {
    key: "cases",
    title: "Одиннадцать проектов, которые уже работают",
    lead:
      "Музеон, Смешарики, Лукоморье, «Сказка», Тальцы, DDX, Саяногорск, " +
      "Мастер Дракона, РобоКвест, GO 360 и Тбилиси — что делали и что вышло.",
    section: "Кейсы",
    minutes: 11,
    intro:
      "Все они собраны на одной технологии: игра открывается прямо в Telegram, " +
      "без установки приложения. Дальше — своя история, свои механики и своя " +
      "публика у каждого.",
    blocks: [
      {
        title: "Музеон, музей под открытым небом",
        text:
          "Задача была вернуть внимание к скульптурам, мимо которых посетители " +
          "просто проходят. Сделали AR-приключение с картой и маршрутами: у " +
          "скульптур проявляются трёхмерные артефакты, а сами статуи оживают " +
          "через нейровидео — говорят и двигаются. Есть сюжет с поиском артефакта " +
          "и образовательные миссии про символику работ.",
      },
      {
        title: "Смешарики",
        text:
          "Riki Group хотели превратить бренд в игру. Встроили AR-игру прямо в " +
          "их приложение Riki Family: игрок собирает праздник для героев, ищет " +
          "потерянные предметы в реальных местах, фармит шарики у домиков-" +
          "персонажей и ловит героев в духе Pokémon Go. В конце получает цифровую " +
          "игрушку, которую забирает в основное приложение.",
      },
      {
        title: "Лукоморье, парк деревянных скульптур в Иркутске",
        text:
          "Хотели, чтобы посетитель не гулял по аллеям, а становился героем " +
          "сказки. Сделали карту с точками квестов, поиск волшебных артефактов " +
          "в дополненной реальности и оживление деревянных скульптур — Баба Яга, " +
          "Кощей, Змей Горыныч заговорили голосами. Игру активно покупают школьные " +
          "экскурсии, о ней рассказывали «Вести Иркутск».",
      },
      {
        title: "Парк «Сказка»",
        text:
          "Вместо стендов и аттракционов — сюжетное путешествие по всей " +
          "территории: нарушен баланс сказочного мира, нужно найти драконьи яйца " +
          "и артефакты для перехода между мирами. Механики привязаны к настоящим " +
          "местам парка — Айва, Альпаки, Дино, Дом вверх дном. Награды и цифровые, " +
          "и настоящие.",
      },
      {
        title: "Тальцы, музей в Иркутской области",
        text:
          "Здесь получился школьный урок краеведения в виде приключения. Сюжет " +
          "построен на реальной поездке Чехова через Сибирь в 1890 году: он " +
          "покупает фотоаппарат, снимает Сибирь, плёнка теряется — игрок " +
          "восстанавливает фотоальбом. Чехов «оживлён» через AI-видео, в каждой " +
          "исторической постройке свои AR-предметы. Единственный кейс с измеренным " +
          "результатом: материал усваивается до 60–70 процентов лучше, чем при " +
          "обычном обучении.",
      },
      {
        title: "Фестиваль DDX Fitness",
        text:
          "Фестиваль превратили в интерактив: AR-квесты по реальным зонам, " +
          "задания разного рода — искать, решать, фотографировать, сканировать. " +
          "Партнёрские бренды встроены в задания, а за действия начисляются " +
          "медали «DDX ENERGY».",
      },
      {
        title: "Саяногорск, город РусАла",
        text:
          "Здесь геймификация работала на город, а не на бизнес. Точка входа — " +
          "портал, за ним квесты, и каждый раскрывает свой слой: шаманская " +
          "Хакасия, стройка алюминиевого гиганта, экология, местная мистика. " +
          "Чеканное панно, древний менгир, садовод — реальные объекты города " +
          "стали артефактами. Вместо табличек и экскурсий — опыт, который " +
          "вовлекает молодёжь и даёт повод гордиться местом.",
      },
      {
        title: "Мастер Дракона",
        text:
          "Геймификация спорта. Десять этапов от разминки до медитации, в " +
          "каждой точке видео-задание с наставником: упражнения на все группы " +
          "мышц, дыхание, внутренняя работа. За прохождение выдаются жетоны " +
          "Смелости, Мощи, Гибкости, Концентрации и Знания. Пример того, как " +
          "игровая оболочка удерживает человека в регулярной практике.",
      },
      {
        title: "РобоКвест, курсы робототехники",
        text:
          "Кейс про воронку продаж, встроенную прямо в игру. Подростки " +
          "проходят AR-квесты по темам курса — схемы, детали, программирование, " +
          "— а в конце оставляют заявку на реальные занятия. Есть " +
          "AI-наставники в видео и связка с физическим оборудованием и " +
          "LEGO-наборами. Работает там, куда обычная реклама не дотягивается.",
      },
      {
        title: "GO 360, Забайкалье",
        text:
          "Совместный проект с платформой GO AND GUIDE 360: маршрут по региону " +
          "превращён в игру внутри Telegram. На каждой точке турист выполняет " +
          "задание и получает бурятскую бусину из можжевельника. Три сюжетные " +
          "линии — природная, историческая, сакральная. Отели, еда и экскурсии " +
          "подключены прямо из игры.",
      },
      {
        title: "Сокровища Грузии, Тбилиси",
        text:
          "AR-игра по улицам города: задания привязаны к реальным точкам, " +
          "артефакты спрятаны в магических цветах, сюжет ведёт маг Давид. " +
          "Доступна круглосуточно через Telegram, к ней подключаются бренды и " +
          "локации. Пример туризма, где историю показывает игра, а не " +
          "экскурсовод.",
      },
      {
        title: "Что общего",
        text:
          "Ни одного установленного приложения — всё открывается в Telegram. " +
          "Везде игра привязана к настоящему месту, а не к экрану. И везде " +
          "механика одна и та же: карта, точки, задания, награды. Ровно то, что " +
          "собирается в конструкторе платформы.",
      },
    ],
    outcome:
      "Цифры результата есть только по Тальцам — остальные кейсы описаны " +
      "качественно. Если будете использовать их в продажах, стоит запросить у " +
      "площадок настоящие показатели: посещаемость, средний чек, повторные визиты.",
  },
  {
    key: "fairyton",
    title: "Приложение FairyTON",
    lead:
      "Что внутри приложения в Telegram: прогресс, оранжерея, квесты, " +
      "друзья и магазин. Здесь же живёт фарминг семечки.",
    section: "Продукты",
    minutes: 5,
    intro:
      "FairyTON — приложение «Волшебного мира» в Telegram. Кабинет и приложение " +
      "показывают одни и те же цифры: балансы, локации и квесты берутся из общего " +
      "источника, поэтому расхождений между ними быть не должно.",
    blocks: [
      {
        title: "Home — прогресс и доход",
        text:
          "Главный экран: кошелёк, профиль, инвентарь, мои локации, друзья. " +
          "Активный доход показывает движение — сколько локаций открыто, квестов " +
          "пройдено, друзей приглашено и сколько накоплено FD Point, токенов и " +
          "FD USD. Пассивный доход — то же за всё время.",
      },
      {
        title: "Farm — оранжерея",
        text:
          "Здесь сажают магические семена и ухаживают за цветами. За уход дают " +
          "игровые баллы, токены, стейбл USD и новые семена. Это и есть фарминг: " +
          "награда приходит не разово, а кругами, пока растение растёт.",
      },
      {
        title: "Бустеры стихии",
        text:
          "Временные усиления: ускоряют рост растений и увеличивают награды. " +
          "Их покупают или выигрывают. Смысл в том, чтобы дойти до цели быстрее, " +
          "а не в том, чтобы получить что-то недоступное иначе.",
      },
      {
        title: "Quest — задания",
        text:
          "У каждого квеста своё название, описание, список задач и награды: " +
          "баллы, токены, улучшения, редкие предметы. У входа есть цена — баллами, " +
          "токенами, FD USD или наградами, поэтому ресурсы приходится планировать. " +
          "К заданиям прилагаются подсказки: аудио, видео, иллюстрации, документы.",
      },
      {
        title: "Game, Friends, Store",
        text:
          "Игровая часть, приглашение друзей по своей ссылке и магазин. Друзья " +
          "важны не только для компании: приглашённые по ссылке считаются в " +
          "профиле и влияют на доход.",
      },
      {
        title: "AI-помощник",
        text:
          "В приложении есть свой помощник «Я из будущего». В кабинете его " +
          "родственница — Фея Мотти, кнопка в правом нижнем углу.",
      },
    ],
    outcome:
      "Приложение и кабинет — две двери в один мир. В приложении играют и " +
      "фармят, в кабинете собирают свои миры и получают за них деньги.",
  },
  {
    key: "welcome",
    title: "Что такое «Волшебный мир»",
    lead:
      "Из чего состоит экосистема, какие в ней роли и на чём здесь " +
      "зарабатывают. Общая картина за пять минут.",
    section: "С чего начать",
    minutes: 5,
    intro:
      "«Волшебный мир» — не офис и не стартап, а цифровая среда, где человек " +
      "выбирает роль и развивается в ней: проходит игры, собирает свои миры, " +
      "участвует в проектах с настоящими клиентами. Уровень вовлечённости " +
      "каждый выбирает сам.",
    blocks: [
      {
        title: "Шесть частей экосистемы",
        text:
          "Платформа без программирования для AR-игр и бизнес-задач. Студия " +
          "и аутсорс-центр. FairyTON — приложение в Telegram. AR-бизнес: сеть " +
          "франшиз. Образовательные курсы. И FairyLand — метавселенная.",
      },
      {
        title: "Что здесь делают",
        text:
          "Исследуют миры, собранные на AI, AR и Web3. Создают свои игры и " +
          "сценарии. Участвуют в проектах с партнёрами и клиентами. Строят " +
          "карьеру и зарабатывают в игровом формате.",
      },
      {
        title: "Роли",
        text:
          "Шесть ролей, между которыми распределены занятия: Герой проходит " +
          "квесты, Ремесленник работает по своей специальности, Патронус " +
          "продвигает и продаёт, Эксперт учит, Мастер ведёт бизнес, Хранитель " +
          "развивает экосистему и вкладывается в неё. Роль выбирают сами, и " +
          "их может быть несколько.",
      },
      {
        title: "Как это устроено по управлению",
        text:
          "Компания работает как DAO — сообщество, где решения принимаются " +
          "участниками, а не одним начальником. Отсюда и роли: это не должности, " +
          "а способы участия.",
      },
      {
        title: "Живые примеры",
        text:
          "Парк Горького, Парк «Сказка», Лукоморье — реальные площадки, где " +
          "миры платформы уже работают. Полный список с описаниями — в разделе " +
          "«Кейсы» этой Книги.",
      },
      {
        title: "На чём зарабатывают",
        text:
          "Игровые монеты, награды и токены. IT-услуги, билеты, лицензии, " +
          "видеопродакшен, геймификация. Партнёрская программа и фонд развития. " +
          "Доход распределяется между командой, партнёрами, инвесторами и " +
          "участниками — принцип простой: зарабатывает один, зарабатывают все.",
      },
      {
        title: "Миссия",
        text:
          "Развивать творческий и финансовый потенциал людей, соединяя " +
          "технологии и смыслы. Проще говоря — дать возможность зарабатывать " +
          "тем, чем интересно заниматься.",
      },
    ],
    outcome:
      "Дальше стоит определиться с ролью — от неё зависит, какие разделы " +
      "кабинета откроются. Описания всех шести есть в Книге Знаний, а начать " +
      "путь можно с заданий первого уровня на главной.",
  },
  {
    key: "platform",
    title: "Что умеет платформа",
    lead:
      "Тринадцать возможностей «Волшебного мира» — от создания локации до " +
      "работы с клиентами. Коротко о каждой, с примером.",
    section: "Платформа",
    minutes: 6,
    intro:
      "«Волшебный мир» — платформа для геймифицированных проектов: AR-квестов, " +
      "игровых локаций и цифровых экосистем. Здесь создают квесты, ведут проекты, " +
      "продают доступ и получают доход. Ниже — из чего платформа состоит.",
    blocks: [
      {
        title: "Вход в экосистему",
        text:
          "Регистрация открывает личный кабинет и всё остальное. Алекс завёл " +
          "кабинет и через пять минут настраивал первую локацию для городского квеста.",
      },
      {
        title: "Главная — каталог локаций",
        text:
          "Витрина готовых миров с категориями, описаниями и превью. Отсюда же " +
          "создаётся своя локация. Юля нашла на главной локацию в Батуми и сделала " +
          "похожую для своего города.",
      },
      {
        title: "Личный кабинет",
        text:
          "Центр управления: мои локации, кошелёк, награды, билеты, профиль, " +
          "подключение криптокошелька. Дмитрий подключил кошелёк и начал продавать " +
          "цифровые награды из своей локации.",
      },
      {
        title: "Создание локации",
        text:
          "Название, категория, описание, геопозиция, медиафайлы — и квест готов " +
          "к запуску. Отель в горах собрал AR-квест прямо по своей территории, и " +
          "туристы исследуют зону отдыха с телефона.",
      },
      {
        title: "Квесты",
        text:
          "Конструктор заданий: кодовые слова, AR-метки, AR-гео, мультивыбор, " +
          "задания с проверкой человеком. Настраиваются условия входа, награды, " +
          "частота и число прохождений. Анна поставила AR-объект на карте города — " +
          "игроки сканируют его и получают награду.",
      },
      {
        title: "Награды и фарминг",
        text:
          "Награды бывают обычные и фарм — вторые приносят доход по циклам. Тимур " +
          "сделал фарм-награду, которую игроки активируют в коллекции и получают " +
          "монеты раз в двенадцать часов.",
      },
      {
        title: "Билеты",
        text:
          "Способ продавать доступ к закрытому: скрытым квестам, мероприятиям, " +
          "коллекционным предметам. Команда выставки выпустила VIP-билет к редкой " +
          "AR-инсталляции в музее.",
      },
      {
        title: "Аналитика",
        text:
          "Статистика по вовлечению, активности, билетам и наградам. Влад увидел, " +
          "что один квест работает лучше остальных, и сделал его центральным.",
      },
      {
        title: "Деньги",
        text:
          "Приём платежей, собственные игровые монеты, отчёты. Культурный центр в " +
          "Сочи продавал билеты через платформу и видел отчёты прямо в кабинете.",
      },
      {
        title: "Команда и задачи",
        text:
          "Распределение задач, вознаграждения, статусы на канбан-доске. Команда из " +
          "пяти человек вела продакшен игры внутри платформы, без сторонних сервисов.",
      },
      {
        title: "Участники и роли",
        text:
          "Каждому участнику своя роль и свои права: владелец, администратор, " +
          "патронус для маркетинга, тестировщик. Настя добавила Патронуса, и тот " +
          "привёл двести игроков через Telegram-канал.",
      },
      {
        title: "Работа с клиентами",
        text:
          "Заявки, оплаты и статусы заказов ведутся внутри платформы — отдельная " +
          "CRM не нужна. Франшиза центра робототехники так и работает.",
      },
      {
        title: "Оформление под свой бренд",
        text:
          "Внешний вид локации настраивается, можно подключить свой домен. Владельцы " +
          "тематического парка сделали платформу частью собственного сайта.",
      },
    ],
    outcome:
      "Коротко: платформа даёт собрать AR-игру или квест без программирования, " +
      "продавать доступ и награды, вести команду и клиентов — и получать за это " +
      "деньги на счёт.",
  },
  {
    key: "roadmap",
    title: "Куда движется «Волшебный мир»",
    lead:
      "Планы компании на ближайший год и на пять лет: что строят, к каким " +
      "деньгам идут и что из этого касается вас.",
    section: "Основы",
    minutes: 5,
    intro:
      "Это цели команды, а не обещания участникам. Читать их стоит так: вот " +
      "куда поедет платформа, на которой вы уже работаете, — и вот какие " +
      "возможности появятся по дороге.",
    blocks: [
      {
        title: "Ближайший год: проверить и вырасти",
        text:
          "Главное сейчас — довести до ума то, что уже работает. Идут бета-тесты " +
          "AR-проектов и платформы геймификации, собирается обратная связь. " +
          "Параллельно расширяют круг корпоративных клиентов: торговые центры, " +
          "парки, туристические объекты, ивенты и бренды. Цель по выручке — " +
          "7 млн рублей в месяц.",
      },
      {
        title: "Что доделывают в платформе",
        text:
          "Административная часть — чтобы создавать игровые локации было проще " +
          "и быстрее. Новые AR-механики и геотрекинг. Веб-версия приложения для " +
          "клиентов. Локализация и роли — чтобы каждый участник видел своё. " +
          "Отдельно строят рекламную платформу для платного трафика.",
      },
      {
        title: "Пять лет: своя экосистема",
        text:
          "Дальняя цель — 700 млн рублей в год и место среди лидеров в цифровых " +
          "развлечениях, геймифицированном образовании и XR. В планах: платформа " +
          "геймификации как SaaS, собственные приложения для iOS и Android, " +
          "решения для XR-очков, продакшен кино и сериалов с AR и AI.",
      },
      {
        title: "DAO и цифровые активы",
        text:
          "Отдельное направление — биржа фриланса внутри DAO, где заказчики и " +
          "исполнители находят друг друга напрямую. И метавселенная, где " +
          "участник владеет цифровыми активами по-настоящему. Плюс выход на " +
          "азиатский, европейский и американский рынки.",
      },
      {
        title: "Что это значит для вас",
        text:
          "Чем дальше едет платформа, тем больше на ней способов заработать: " +
          "новые механики, новые рынки, новые роли. Ранние участники получают " +
          "то, чего не будет у пришедших позже, — место в основании и опыт " +
          "работы с инструментами до того, как ими начнут пользоваться все.",
      },
    ],
  },
  {
    key: "beta",
    title: "Вы участвуете в бета-тесте",
    lead:
      "Что значит быть на платформе сейчас, пока она достраивается, и что " +
      "вам это даёт.",
    section: "Основы",
    minutes: 4,
    intro:
      "Платформа работает, но её ещё строят. Вы зашли в тот момент, когда ваше " +
      "мнение меняет продукт, — дальше такой возможности не будет.",
    blocks: [
      {
        title: "Почему бета, а не готовый продукт",
        text:
          "Геймификация, AR, AI и no-code — четыре технологии, которые по " +
          "отдельности работают давно, а вместе почти нигде. Собрать их в одну " +
          "платформу можно только на живых людях: что показалось сложным, где " +
          "человек застрял, какая механика не сработала. Поэтому доступ открыли " +
          "до того, как всё доделали.",
      },
      {
        title: "Что вам доступно",
        text:
          "Все инструменты платформы без ограничений: создание локаций, квесты, " +
          "награды, работа с клиентами. Новые механики приходят к вам первыми — " +
          "до того, как их увидит рынок. И ваши замечания попадают напрямую к " +
          "команде, а не в общую очередь поддержки.",
      },
      {
        title: "Где будут шероховатости",
        text:
          "Честно: что-то будет работать не с первого раза. Часть разделов " +
          "заполнена не до конца, часть механик меняется на ходу. Если " +
          "наткнулись на странность — это не вы сделали не так, это повод " +
          "написать команде. Такие сообщения сейчас ценнее всего.",
      },
      {
        title: "Что делать прямо сейчас",
        text:
          "Пройдите первый уровень — он проведёт по кабинету за несколько шагов. " +
          "Дальше выберите роль: от неё зависит, какие инструменты откроются. " +
          "И загляните в приложение FairyTON — там живёт игровая часть, " +
          "фарминг и ежедневные задания.",
      },
    ],
  },
  {
    key: "fairyland",
    title: "FairyLand — метавселенная",
    lead:
      "Мир, куда ведут Сказочные Врата: как он устроен, что такое первая " +
      "глава и зачем проходить путь первопроходца.",
    section: "Основы",
    minutes: 6,
    intro:
      "FairyLand — игровая часть экосистемы, где локации связаны сюжетом, а не " +
      "просто списком. Проходя её, человек выбирает роль и получает первые " +
      "награды.",
    blocks: [
      {
        title: "Что это за мир",
        text:
          "Цифровая вселенная, где реальные места и виртуальные локации " +
          "переплетены. Игрок выбирает роль — исследователь, ремесленник, " +
          "инвестор, автор, создатель миров — и выполняет квесты в AR-локациях. " +
          "Технически это связка дополненной реальности, искусственного " +
          "интеллекта и no-code инструментов.",
      },
      {
        title: "Сказочные Врата — вход",
        text:
          "Первая локация, где человек в роли гостя знакомится с игрой, а игра " +
          "с ним. Пройдя её, он оказывается в основном мире и получает первый " +
          "приз. Заявлено, что первые десять тысяч игроков получают пожизненный " +
          "статус Героя. Дальше выбирается роль и открываются новые локации.",
      },
      {
        title: "Первая глава: путь первопроходца",
        text:
          "Сейчас открыта первая глава — обучающая. В ней три вида локаций: " +
          "внутренние локации метавселенной, локации проектов-партнёров и " +
          "AR-локации. Механика связывает их так, чтобы можно было идти " +
          "свободно и ничего не пропустить. Прошедшие получают доступ к " +
          "Оранжерее Хранителей, где артефакты меняются на Легендарное Семя.",
      },
      {
        title: "Куда ведут локации",
        text:
          "Ювелирная мастерская — там создают магические кольца. Рынок " +
          "ремесленников — торговля и создание предметов. Лунная обсерватория — " +
          "место Патронусов. Академия волшебства — знания и Легендарный " +
          "Изумруд. Город мастеров — для тех, кто строит свою мастерскую. " +
          "Список пополняется по мере открытия глав.",
      },
      {
        title: "Что обещано за прохождение",
        text:
          "Игровые баллы и награды с первых шагов, рейтинг первопроходцев и " +
          "призы в игровом капитале. Отдельно заявлен FlowerBox первопроходца — " +
          "набор игровых активов, который вырастает из посаженного Семени.",
      },
      {
        title: "Про заявленные суммы — честно",
        text:
          "В описании мира встречаются цифры: пассивный доход в тысячу " +
          "долларов в месяц как цель проекта, призы от тысячи до десяти тысяч в " +
          "игровом капитале. Это заявленные ориентиры и игровые величины, а не " +
          "гарантированный заработок. Игровой капитал тратится внутри " +
          "платформы. Если строите на этом свои расчёты, уточните у команды " +
          "текущие условия — они меняются по мере открытия глав.",
      },
    ],
  },
  {
    key: "rings",
    title: "Ювелирная мастерская: кольца по ролям",
    lead:
      "Шесть колец коллекции — по одному на каждую роль. Что даёт каждое и " +
      "почему выпуск ограничен.",
    section: "Продукты",
    minutes: 4,
    intro:
      "Кольца — цифровые артефакты, привязанные к ролям. Владение " +
      "подтверждается технологией NFT, привилегии заявлены бессрочными.",
    blocks: [
      {
        title: "Кольцо Героя",
        text:
          "Для тех, кто исследует мир и разгадывает его загадки. Даёт " +
          "пожизненный статус героя и раздачи редких артефактов.",
      },
      {
        title: "Кольцо Ремесленника",
        text:
          "Открывает создание цифровых предметов, продажу своих работ внутри " +
          "метавселенной и особые условия на платформе.",
      },
      {
        title: "Кольцо Патронуса",
        text:
          "Артефакт тех, кто ведёт за собой: позволяет собирать гильдии, " +
          "объединять сообщество и зарабатывать на своей аудитории.",
      },
      {
        title: "Кольцо Эксперта",
        text:
          "Ключ к обучающей части: владелец создаёт курсы, учит других игроков " +
          "и зарабатывает на своих знаниях.",
      },
      {
        title: "Кольцо Мастера",
        text:
          "Для предпринимателей: открывает бизнесы внутри метавселенной, " +
          "управление проектами и строительство своих миров.",
      },
      {
        title: "Кольцо Хранителя",
        text:
          "Инвестиционная роль: доступ к закрытым проектам и ранним этапам " +
          "вложений в экономику мира.",
      },
      {
        title: "Почему выпуск ограничен",
        text:
          "Заявлено несколько сотен колец, после чего коллекция не " +
          "повторяется. У каждого кольца цифровая подпись, подтверждающая " +
          "подлинность, и доступ к закрытым событиям и квестам. Условия " +
          "выпуска стоит уточнять у команды — коллекция выходит партиями.",
      },
    ],
  },
  {
    key: "services",
    title: "Услуги команды",
    lead:
      "Что «Волшебный мир» делает для бизнеса помимо платформы: разработка, " +
      "AI, видео, аватары, визуал, маркетинг и трафик.",
    section: "Бизнес",
    minutes: 7,
    intro:
      "Эти направления работают отдельно от платформы — их заказывают как " +
      "обычные услуги. Полезно знать, если ведёте клиента, которому нужна не " +
      "геймификация, а продакшен или разработка.",
    blocks: [
      {
        title: "IT-разработка",
        text:
          "Цифровые продукты под ключ — от проектирования до запуска. " +
          "Технологии: AI, AR, Web3, приложения в Telegram, no-code. Заявлена " +
          "экономия до тридцати процентов бюджета за счёт готовых модулей. " +
          "Подходит стартапам и компаниям, которым нужен технологический " +
          "партнёр, а не разовый подрядчик.",
      },
      {
        title: "Интеграция AI в бизнес",
        text:
          "Внедрение ИИ в процессы компании: анализ структуры, проектирование " +
          "решения, техническая реализация. В продажах — автоматизация " +
          "лидогенерации, прогноз поведения клиентов, персонализация " +
          "предложений. В трафике — управление ставками и оптимизация " +
          "стоимости конверсии. В найме — оценка кандидатов и автоматизация " +
          "работы с сотрудниками.",
      },
      {
        title: "AI-видеопродакшен",
        text:
          "Видео и аудио, собранные с помощью нейросетей и сценарной работы: " +
          "ролики, которые досматривают, звук, который приятно слушать, " +
          "контент под лендинг, соцсети и рекламу. Ориентировано на бренды и " +
          "digital-агентства, которым нужна скорость и продакшен под ключ.",
      },
      {
        title: "Цифровые аватары",
        text:
          "Контент для соцсетей без съёмок: аватар делается похожим на вас или " +
          "вашего представителя, настраиваются мимика и жесты. Дальше — " +
          "сценарии, генерация видео с озвучкой на любом языке, адаптация под " +
          "разные аудитории и площадки. Экономит бюджет и время на " +
          "производство.",
      },
      {
        title: "Визуальная упаковка",
        text:
          "Иллюстрации, графика, 3D-объекты и тексты для оформления проекта: " +
          "концептуальные иллюстрации, графика под соцсети и лендинги, " +
          "моделирование и анимация объектов для геймификации и презентаций, " +
          "копирайтинг.",
      },
      {
        title: "Маркетинг 3.0",
        text:
          "Продвижение через связку аналитики, персонализации и технологий — " +
          "AI, AR, Web3 и геймификация. Задача сформулирована так: не кричать в " +
          "пустоту, а выстраивать связь с клиентом. Результат — узнаваемость, " +
          "новая аудитория и удержание текущих клиентов.",
      },
      {
        title: "Трафик",
        text:
          "Привлечение целевой аудитории: управление платной рекламой для " +
          "быстрого результата и SEO для устойчивого органического роста. Есть " +
          "отдельные подходы для Web3, мобильных приложений и игр — там " +
          "аудитория ищется иначе, чем в обычном бизнесе.",
      },
    ],
  },
  {
    key: "gamification",
    title: "Геймификация: что это и как продаётся",
    lead:
      "Зачем бизнесу игра вместо рекламы, что такое Welcome-квест и что " +
      "входит в пакет «Старт».",
    section: "Бизнес",
    minutes: 6,
    intro:
      "Геймификация — то, что «Волшебный мир» продаёт бизнесу. Полезно знать " +
      "формулировки: ими объясняют ценность клиенту.",
    blocks: [
      {
        title: "Почему это работает",
        text:
          "Игровые задания и награды ведут клиента по воронке и дают повод " +
          "вернуться. В материалах заявлен рост продаж и конверсии на треть и " +
          "оптимизация бюджета втрое. Отдельный аргумент — аудитория до " +
          "двадцати пяти: с ней игра работает там, где обычная реклама уже не " +
          "читается.",
      },
      {
        title: "Что именно предлагается",
        text:
          "No-code платформа для создания AR-игр, квестов и игровых механик. " +
          "Ключевое слово — no-code: локацию собирает маркетолог или " +
          "организатор, а не разработчик. Применяют в маркетинге, обучении и " +
          "туризме.",
      },
      {
        title: "Welcome-квест",
        text:
          "Формат знакомства с брендом: интерактивные задания и свой сценарий " +
          "внутри вселенной FairyWorld. Порядок работы — заявка, разработка " +
          "концепции, создание и тестирование, запуск. После запуска идёт " +
          "маркетинговая поддержка: видеодемонстрация кейса, анонс " +
          "коллаборации, рекомендации по продвижению.",
      },
      {
        title: "Пакет «Старт»",
        text:
          "Курс плюс лицензия на создание своей игровой локации. За шесть " +
          "модулей человек осваивает геймификацию, AR, AI и no-code и делает " +
          "настоящий квест под свой проект — бизнес, школу, фестиваль, бренд. " +
          "Есть менторские сессии и живые встречи, плюс вход в сообщество " +
          "разработчиков экосистемы.",
      },
      {
        title: "Что говорить клиенту",
        text:
          "Сильная сторона — низкий порог: игра открывается в Telegram, " +
          "устанавливать ничего не нужно. Это снимает главное возражение " +
          "офлайн-площадок. Цифры роста берите из кейсов осторожно: подтверждён " +
          "результат пока по Тальцам, остальное описано качественно.",
      },
    ],
  },
  {
    key: "arbusiness",
    title: "AR-бизнес: как на этом зарабатывают площадки",
    lead:
      "Модель для парков, музеев и торговых центров: игра как аттракцион, " +
      "который продаётся по билету.",
    section: "Бизнес",
    minutes: 4,
    intro:
      "Здесь геймификация выступает не рекламой, а самостоятельным источником " +
      "дохода — по той же логике, что колесо обозрения или квест-комната.",
    blocks: [
      {
        title: "Суть модели",
        text:
          "Реальное пространство превращается в цифровую игру: посетители " +
          "разгадывают загадки, ищут сокровища, взаимодействуют с персонажами " +
          "прямо в смартфоне. Для площадки это рост посещаемости, вовлечённости " +
          "и дохода без вложений в физическую инфраструктуру.",
      },
      {
        title: "Сколько стоит вход для посетителя",
        text:
          "В материалах указаны две цены: сто рублей за сутки доступа к игре и " +
          "тысяча за неделю. Низкий порог — часть замысла: билет покупают " +
          "спонтанно, а не планируют заранее.",
      },
      {
        title: "Как это устроено технически",
        text:
          "Приложение работает в Telegram и доступно на iOS и Android. Игрок " +
          "проходит квесты, открывает сюжеты и общается с персонажами. " +
          "Площадке не нужно разрабатывать своё приложение и уговаривать " +
          "посетителя его установить.",
      },
      {
        title: "Кому предлагать",
        text:
          "Парки, музеи, торговые центры, туристические объекты, фестивали. " +
          "То есть места, где человек уже физически находится и располагает " +
          "временем, — там игра конкурирует не за внимание, а за досуг.",
      },
    ],
  },
  {
    key: "economy",
    title: "Экономика платформы",
    lead:
      "Из чего складывается доход экосистемы и как он распределяется между " +
      "участниками.",
    section: "Бизнес",
    minutes: 4,
    intro:
      "Принцип, который команда ставит в основу: зарабатывает один — " +
      "зарабатывают все. Ниже — как это описано в материалах проекта.",
    blocks: [
      {
        title: "Откуда берутся деньги",
        text:
          "Источников несколько: IT-услуги, продажа билетов в AR-локации, " +
          "лицензии, видеопродакшен и геймификация под заказ. Внутри " +
          "платформы обращаются игровые монеты, награды и токены.",
      },
      {
        title: "Как распределяется",
        text:
          "Заявлено четыре стороны: команда, партнёры и франшизы, инвесторы и " +
          "пользователи экосистемы. Отдельно упомянуты партнёрская программа, " +
          "краудфандинг и фонд развития молодёжи.",
      },
      {
        title: "Про токены — важное",
        text:
          "У проекта есть токен FD и материалы по его продаже через внешний " +
          "сервис. Это отдельная финансовая история со своими рисками, и " +
          "решение о покупке — личное дело каждого. Ни платформа, ни эта " +
          "статья не дают инвестиционных советов: если рассматриваете участие, " +
          "разбирайтесь самостоятельно и не вкладывайте больше, чем готовы " +
          "потерять.",
      },
    ],
  },
  {
    key: "courses",
    title: "Образовательные курсы",
    lead:
      "Курс «Геймификация и игровые технологии нового поколения»: программа, " +
      "формат и что получается на выходе.",
    section: "Обучение",
    minutes: 3,
    intro:
      "Курс для тех, кто хочет применять игровые технологии в бизнесе, " +
      "образовании или своих проектах.",
    blocks: [
      {
        title: "Что в программе",
        text:
          "Основы гейм-дизайна и игровых механик, инструменты no-code, работа " +
          "с нейросетями — тексты, видео, 3D, звук. Программа соединяет " +
          "гейм-дизайн, нейросетевой продакшен, дополненную реальность и " +
          "управление проектами.",
      },
      {
        title: "Формат",
        text:
          "Шесть занятий за месяц, онлайн или очно, с практикой и доступом к " +
          "платформе. Есть менторские сессии и живые встречи.",
      },
      {
        title: "Результат",
        text:
          "Участник создаёт собственную мини-игру на платформе, тестирует её и " +
          "защищает как финальный проект. То есть на выходе не конспект, а " +
          "работающий квест, который можно показывать клиенту.",
      },
    ],
  },
];

export const articleByKey = (key) => ARTICLES.find((a) => a.key === key) || null;
